<div class="navbar-container max-width fixed-bottom d-flex safe-area-bottom">
  <nav class="navbar navbar-bottom bg-white flex-fill pr-0">
    <app-navbar-bottom-icon-feed></app-navbar-bottom-icon-feed>

    <div
      *ngIf="isLoggedIn"
      [ngClass]="{
        'icon call': !locationFavorites?.favoritesCount && !locationFavorites?.tryMeCount,
        'goal-red': locationFavorites?.tryMeCount,
        'heart-red': locationFavorites?.favoritesCount && !locationFavorites?.tryMeCount
      }"
      class="icon-v2 w-31px"
      (click)="onFavoritesClick()"
    ></div>

    <span
      *ngIf="!isLoggedIn"
      class="icon-v2 play mb-1 w-31px"
      (click)="onVideoClick()"
    ></span>

    <div class="visibility-hidden"></div>
  </nav>

  <app-navbar-bottom-semicircle-notch [isPrimary]="canEditHours">
    <span *ngIf="canEditHours">
      <a
        *ngIf="userRestaurants.length == 1"
        appHrefNone
        class="icon-v2 clock scale-1_2 pt-1-8rem"
        (click)="openHoursEditModal(userRestaurants[0])"
      ></a>
    </span>

    <app-navbar-bottom-restaurants-picker
      *ngIf="!canEditHours"
      [explore]="true"
      [searchResult]="searchResult"
      (restaurantSelected)="onRestaurantsPickerSelected($event)"
    ></app-navbar-bottom-restaurants-picker>
  </app-navbar-bottom-semicircle-notch>

  <nav class="navbar navbar-bottom bg-white flex-fill pl-0">
    <div class="visibility-hidden"></div>

    <app-image-picker
      [enableImageSelectModal]="true"
      (save)="onImageUploaded($event)"
      style="width: 31px !important;"
    ></app-image-picker>

    <app-navbar-bottom-icon-user [ngClass]="{'visibility-hidden': !isLoggedIn}"></app-navbar-bottom-icon-user>
  </nav>
</div>
